<template>
  <div class="panel-group no-head-wrap" id="accordion" role="tablist">
    <vue-custom-scrollbar class="scroll-area" :settings="settings">
      <div
      v-for="tableauDetail in tableauDetails"
      :key="tableauDetail.id"
      class="panel panel-default"
    >
        <div class="panel-heading" role="tab">
            <h4 class="panel-title">
                <a block role="button" v-b-toggle="'collapse-'+ tableauDetail.id">
                    {{ tableauDetail.nom }}
                </a>
            </h4>
        </div>
      <b-collapse :id="`collapse-${tableauDetail.id}`" role="tabpanel">
        <div class="panel-collapse">
          <div class="panel-body">
            <loading v-if="generating()" />
            <b-list-group>
              <b-list-group-item>
                <b-button v-if="!generating()" @click="openNewTemplateModal(tableauDetail.id)" class="txt-btn" variant="outline-primary">
                  <font-awesome-icon :icon="['fas', 'plus']" /> Nouveau template
                </b-button>
                <b-button v-else class="txt-btn" variant="primary">
                  <b-spinner small type="grow"></b-spinner> En attente...
                </b-button>
                <template-fiche
                  :ref="'ajoutTemplate-'+tableauDetail.id"
                  :onglet="tableauDetail.id"
                  @addTemplate="handleAddTemplate" />
              </b-list-group-item>
              <template v-if="templateData[tableauDetail.id].length !== 0">
                <b-list-group-item
                  v-for="data in templateData[tableauDetail.id]"
                  :key="'template-'+data.id"
                  active
                  :class="{'notallowed': generating()}"
                  @click.stop="showFiche(data.id)"
                >
                  <div class="d-flex">
                    <div class="p-2 flex-grow-1">
                      {{ data.nom }}
                    </div>
                    <div class="action pt-1">
                      <b-button @click.prevent.stop="openEditTemplateModal({...data, onglet: tableauDetail.id})" class="edit" size="sm" variant="outline-secondary">
                        <font-awesome-icon :icon="['fas', 'edit']" />
                      </b-button>
                      <b-button @click.prevent.stop="showDeleteConfirmation({...data, onglet: tableauDetail.id})" class="delete" size="sm" variant="outline-secondary">
                        <font-awesome-icon :icon="['fas', 'trash']" />
                      </b-button>
                    </div>
                  </div>
                </b-list-group-item>
              </template>
              <template v-else>
                <b-list-group-item>
                  Aucun template trouvé, veuillez en créer
                </b-list-group-item>
              </template>
            </b-list-group>
          </div>
        </div>
      </b-collapse>
    </div>
    </vue-custom-scrollbar>
    <template-fiche
      ref="editTemplate"
      type="edit"
      @editNom="handleEditNom"
      />
  </div>
</template>

<script>
import loading from '../../loading'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { mapActions, mapGetters } from 'vuex'
import { defaultFicheLayout } from '../../../config/constanteUse'
import templateFiche from '../modal/templateFiche'
import { EventBus, events } from '../../../eventBus'
export default {
  components: {
    loading,
    templateFiche,
    vueCustomScrollbar
  },
  props: {
    tableauDetails: {
      type: Array
    },
    templateData: null
  },
  data () {
    return {
      defaultFicheLayout,
      settings: {
        maxScrollbarLength: 60
      }
    }
  },
  mounted () {
    EventBus.$on(events.DELETE_TEMPLATE, async (template) => {
      const res = await this.deleteTemplateFiche(template)
      this.setMessage(res)
      // this.$toaster.info(res, { timeout: 3000 })
    })
  },
  methods: {
    ...mapActions(['setMessage', 'addGeneratedFiche', 'generateFicheEspace', 'setCurrentFiche', 'createTemplateFiche', 'updateFicheNom', 'deleteTemplateFiche']),
    ...mapGetters(['generating', 'generatedFiche']),
    openNewTemplateModal (id) {
      this.$refs[`ajoutTemplate-${id}`][0].open()
    },
    openEditTemplateModal (data) {
      this.$refs[`editTemplate`].openEdit(data)
    },
    showFiche (id) {
      if (this.generating()) {
        return
      }
      this.setCurrentFiche(id)
    },
    async handleAddTemplate (data) {
      const res = await this.createTemplateFiche(data)
      this.setMessage(res)
      // this.$toaster.info(res, { timeout: 3000 })
    },
    async handleEditNom (data) {
      const res = await this.updateFicheNom(data)
      this.setMessage(res)
      // this.$toaster.info(res, { timeout: 3000 })
    },
    showDeleteConfirmation (template) {
      this.$bvModal.msgBoxConfirm(`Voulez-vous vraiment supprimer le template "${template.nom}" ?`, {
        modalClass: 'base-modal',
        title: 'Suppression de template',
        buttonSize: 'sm',
        headerClass: 'bg-danger',
        okVariant: 'outline-danger',
        okTitle: 'OUI',
        cancelVariant: 'outline-primary',
        cancelTitle: 'NON',
        footerClass: 'p-2',
        hideHeaderClose: true
      })
        .then(async value => {
          if (value) {
            EventBus.$emit(events.DELETE_TEMPLATE, template)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .no-head-wrap {
    margin-top: 95px;
  }
  #accordion {
    font-family: "Noto Sans";
    user-select: none;
    button[disabled="disabled"]{
      cursor: not-allowed;
    }
    a:hover, a:focus{
      text-decoration: none;
      outline: none;
    }
    .panel{
        border: none;
        box-shadow: none;
        border-radius: 0;
        margin-bottom: 15px;
    }
    .panel-action{
      margin-bottom: 15px;
      margin-bottom: 40px;
      margin-top: 30px;
      button {
        border-radius: 0;
        height: 25px;
        line-height: 25px;
      }
    }
    .panel-heading{
        padding: 0;
        border-radius:0;
        border: none;
    }
    .panel-title{
      margin-bottom: -1px;
      text-align: center;
    }
    .panel-title a{
      border-radius: 3px;
      background-color: #2b3085;
      color: #fff;
      display: block;
      font-size: 14px;
      line-height: 28px;
      height: 28px;
    }
    .panel-title a.collapsed{
        /* background: #f8f8f8;
        color: black; */
    }
    .panel-title a.collapsed:hover{
        color: #fff;
    }
    .panel-title a:before{
        /* content: "";
        width: 55px;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
        position: absolute;
        top: 0;
        left: -13px;
        transform: skewX(-25deg);
        transition: all 0.5s ease 0s; */
    }
    .panel-title a.collapsed:hover:before{
        /* background: #073f6e; */
    }
    .panel-title a:after{
        position: absolute;
        left: 10px;
        top: 50%;
        color: #fff;
        transform: translateY(-50%);
    }
    .panel-title a.collapsed:after{
        color: #9f9f9f;
    }
    .panel-title a.collapsed:hover:after{
        color: #fff;
    }
    .panel-body{
        font-size: 14px;
        color: #2b3085;
        line-height: 25px;
        padding: 0;
        position: relative;
        border: none;
        transition: all 0.5s ease 0s;
        .list-group {
          .form-group {
            margin-bottom: 10px;
          }
        }
        .list-group-item{
          padding-top: 0px;
          padding-bottom: 0px;
          font-size: 12px;
          font-weight: 600;
          border: 1px solid #2b3085;
          border-top: none;
          border-radius: 0;
          padding-left: 5px;
          padding-right: 5px;
          & > button {
            height: 25px;
            margin-top: 5px;
            margin-bottom: 5px;
            font-size: 14px;
            line-height: 25px;
          }
          &.active {
            background-color: #9395c1;
            border: none;
            border-left: 1px solid #2b3085;
            border-right: 1px solid #2b3085;
          }
          &:last-child {
            border-radius: 0 0 3px 3px;
          }
          .custom-control-label {
            padding-top: 4px;
          }
        }
    }
    .panel-body p{
        margin-bottom: 0;
    }
    .list-group-item.active{
      cursor: pointer;
      border: 1px solid rgba(0, 0, 0, 0.13);
      &.notallowed{
        cursor: wait;
      }
    }
    .action{
      button {
        border: none;
        background-color: transparent !important;
        color: #fff !important;
      }
    }
    .row-espace {
      align-items: center;
      padding-left: 25px;
    }
    .scroll-area {
      height: calc(100vh - 200px);
      padding-right: 15px;
    }
    .ps__thumb-x, .ps__thumb-y {
      background-color: #2b3085 !important;
      width: 6px !important;
      right: 0;
      &:hover {
        background-color: #2b3085;
        width: 6px;
      }
    }
    .ps__rail-y {
      display: block;
      width: 8px;
      border: 1px solid #2b3085;
      border-radius: 6px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/template/listeTemplate.vue